// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myNav {
    background-color:rgb(255, 255, 255) !important;
    /* background-color: mintcream !important; */
    /* background-color: #347571 !important; */
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
    font-family: 'Open Sans', sans-serif;
    color: #346571;
    z-index: 11;
    display: flex;
    width: 100%;
    height: 65px;
}

.clickable {
    cursor: pointer;
}

.logoImg {
    height: 40px;
}

.navText {
    color:#c2fbd7;
    font-size: 18px;
    /* margin-top: 10px; */
    transition: color 0.3s;
}

.navbar-brand:focus, .navbar-brand:hover {
    color: rgb(253 253 253);
}

@media only screen and (max-width: 480px) {
    .navText {
        color:#c2fbd7;
        font-size: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styleSheet/Nav.css"],"names":[],"mappings":"AAAA;IACI,8CAA8C;IAC9C,4CAA4C;IAC5C,0CAA0C;IAC1C,mDAAmD;IACnD,oCAAoC;IACpC,cAAc;IACd,WAAW;IACX,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,aAAa;QACb,eAAe;IACnB;AACJ","sourcesContent":[".myNav {\n    background-color:rgb(255, 255, 255) !important;\n    /* background-color: mintcream !important; */\n    /* background-color: #347571 !important; */\n    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n    font-family: 'Open Sans', sans-serif;\n    color: #346571;\n    z-index: 11;\n    display: flex;\n    width: 100%;\n    height: 65px;\n}\n\n.clickable {\n    cursor: pointer;\n}\n\n.logoImg {\n    height: 40px;\n}\n\n.navText {\n    color:#c2fbd7;\n    font-size: 18px;\n    /* margin-top: 10px; */\n    transition: color 0.3s;\n}\n\n.navbar-brand:focus, .navbar-brand:hover {\n    color: rgb(253 253 253);\n}\n\n@media only screen and (max-width: 480px) {\n    .navText {\n        color:#c2fbd7;\n        font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
